import React from 'react'
import './logo.css'

export const Logo = () => {
    return (
        <div className='logo'>
            <div className="logoTop">{"Rare Finds"}</div>
            <div className="logoBottom">{"Vinyl Shop"}</div>
        </div>
    )
}
